<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg id="Capa_1" xmlns="http://www.w3.org/2000/svg" width="38.896" height="55"
     viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g fill="currentColor" transform="translate(-12.2 -6.3)">
  <circle cx="256" cy="220" r="17.5"/>
  <path d="M256,2.5C136.1,2.5,38.5,100.1,38.5,220c0,111.4,86.9,206.6,197.7,216.6l2.3,0.2v37.7H176c-9.6,0-17.5,7.9-17.5,17.5
    s7.9,17.5,17.5,17.5h160c9.6,0,17.5-7.9,17.5-17.5s-7.9-17.5-17.5-17.5h-62.5v-37.7l2.3-0.2c110.9-10,197.7-105.2,197.7-216.6
    C473.5,100.1,375.9,2.5,256,2.5z M437.4,240.3c-4.9,44.3-26,85.2-59.3,115.3c-33.6,30.3-76.9,46.9-122.1,46.9
    c-45.1,0-88.5-16.7-122.1-46.9c-33.3-30-54.4-71-59.3-115.3l-0.3-2.8H96c9.6,0,17.5-7.9,17.5-17.5s-7.9-17.5-17.5-17.5H74.3
    l0.3-2.8c4.9-44.3,26-85.2,59.3-115.3c33.6-30.3,76.9-46.9,122.1-46.9c45.1,0,88.5,16.7,122.1,46.9c33.3,30,54.4,71,59.3,115.3
    l0.3,2.8H416c-9.6,0-17.5,7.9-17.5,17.5s7.9,17.5,17.5,17.5h21.7L437.4,240.3z"/>
  <path d="M256,122.5c-53.8,0-97.5,43.7-97.5,97.5s43.7,97.5,97.5,97.5s97.5-43.7,97.5-97.5S309.8,122.5,256,122.5z M256,282.5
    c-34.5,0-62.5-28-62.5-62.5s28-62.5,62.5-62.5c34.5,0,62.5,28,62.5,62.5S290.5,282.5,256,282.5z"/>
</g>
</svg>
